<template>
  <v-card elevation="0" class="pl-4 pr-4 pt-2" style="border-radius: 20px;">
    <v-card-title class="" v-if="with_title">
      <v-row align='center' justify='end'>
        <slot name="title"></slot>
        <v-spacer></v-spacer>
        <slot name="btn-slot"></slot>
      </v-row>
    </v-card-title>
    <v-divider v-if="with_divider" class="mt-3 pb-4"></v-divider>
    <v-card-text class="pa-2">
      <slot name="content"></slot>
    </v-card-text>
    <v-card-actions class="justify-end" v-if="with_actions">
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>

  <!--
    <base-card>
      <template slot="title"></template>
      <template slot="btn-slot"></template>
      <template slot="content"></template>
      <template slot="actions"></template>
    </base-card>
   -->
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    with_title: {
      type: Boolean,
      default: true
    },
    with_divider: {
      type: Boolean,
      default: false
    },
    with_actions: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  }
};
</script>
